export default {
  state: {
    cartItems: {}
  },
  mutations: {
    setCartItems(state, payload) {
      state.cartItems = payload;
    }
  },
  actions: {
    setCartItems({ commit }, payload) {
      commit("setCartItems", payload);
    }
  },
  getters: {
    cartItems(state) {
      return state.cartItems;
    }
  }
};
